import SiteLayout from "@/components/feature/SiteLayout";
import ContactHero from "./components/ContactHero";
import ContactForm from "./components/ContactForm";
import ContactInfoPanel from "./components/ContactInfoPanel";

export default function SiteContactPage() {
  return (
    <SiteLayout navVariant="solid">
      <ContactHero />

      <section className="py-12 md:py-16 bg-[#FAF5EC]">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <ContactForm />
        </div>
      </section>

      {/* Contact info row */}
      <section className="py-16 md:py-20 bg-white border-t border-ink-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
            <div>
              <div className="text-xs uppercase tracking-[0.18em] text-brand-600 font-bold mb-2">
                Prefer to talk?
              </div>
              <h2 className="font-display text-2xl md:text-4xl font-bold text-ink-900 tracking-tight">
                Real humans, real numbers, no call center.
              </h2>
            </div>
          </div>
          <ContactInfoPanel />
        </div>
      </section>

      {/* Bottom reassurance strip */}
      <section className="py-14 md:py-16 bg-[#FAF5EC] border-t border-ink-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              { icon: "ri-time-line", title: "Reply within the hour", desc: "During business hours, real humans reply to every quote request within 60 minutes." },
              { icon: "ri-price-tag-3-line", title: "Flat-rate, no surprises", desc: "Your quote is the price you pay. No hourly meters, no fuel surcharges, no fine print." },
              { icon: "ri-shield-check-line", title: "Licensed & insured", desc: "USDOT #2841930 · Full-replacement-value coverage included on every move at no extra cost." },
            ].map((item) => (
              <div key={item.title} className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center rounded-lg bg-brand-100 text-brand-600">
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <div>
                  <h3 className="font-display text-lg font-bold text-ink-900 mb-1.5">{item.title}</h3>
                  <p className="text-sm text-ink-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}